import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { FiActivity } from 'react-icons/fi';
import NodeWrapper from './NodeWrapper';
import { VISUAL_NODE_HEIGHT_CLASS } from '../layoutConfig';
import { getNodeAccent } from '../config/nodeVisualConfig';

const LineChartNode = memo(({ data, selected }) => {
  const accent = getNodeAccent('line_node', data);
  return (
    <NodeWrapper
        selected={selected}
        title="Line Chart Node"
        type="VISUALIZATION"
        accent={accent}
        icon={FiActivity}
        className={`${VISUAL_NODE_HEIGHT_CLASS} flex flex-col`}
        isHighlighted={data.isHighlighted}
    >
        {/* Input: Data Source */}
        <Handle
            type="target"
            id="input_0"
            position={Position.Left}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />

        <div className="space-y-3">
             <div className="bg-bg-3 p-4 rounded-lg border border-[var(--divider)] flex items-center justify-between">
                 <div className="flex items-center gap-3">
                     <div
                        className="w-12 rounded-full shadow-sm"
                        style={{
                            backgroundColor: data.color || '#2962FF',
                            height: `${Math.max(data.lineWidth || 2, 2)}px`
                        }}
                     ></div>
                 </div>
                 <div className="flex flex-col items-end">
                    <span className="text-[10px] font-bold text-fg-3 uppercase tracking-wider">Thickness</span>
                    <span className="text-xs font-mono font-bold text-fg-1">
                        {data.lineWidth || 2}px
                    </span>
                 </div>
            </div>
        </div>

        {/* Output: Configuration Data — accent-tinted */}
        <Handle
            type="source"
            position={Position.Right}
            className="!w-2.5 !h-2.5 !border-2 !border-[var(--bg-2)] transition-transform hover:scale-125"
            style={{ background: accent }}
        />
    </NodeWrapper>
  );
});

export default LineChartNode;
